import React, { useEffect, useState } from 'react';
import { BookOpenIcon, ShoppingBagIcon, TrendingUpIcon, HandshakeIcon } from 'lucide-react';
export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const services = [{
    title: 'Insights',
    description: 'Content and newsletter providing AI insights for creators.',
    icon: <BookOpenIcon className="w-8 h-8" data-id="element-305" />,
    color: 'from-blue-500 to-blue-400',
    iconColor: 'text-white',
    sectionId: 'insights'
  }, {
    title: 'Products',
    description: 'AI-based products including Newsfiliate.',
    icon: <ShoppingBagIcon className="w-8 h-8" data-id="element-306" />,
    color: 'from-green-500 to-green-400',
    iconColor: 'text-white',
    sectionId: 'products'
  }, {
    title: 'Growth',
    description: 'Directory platform showcasing creator recommendations.',
    icon: <TrendingUpIcon className="w-8 h-8" data-id="element-307" />,
    color: 'from-purple-500 to-purple-400',
    iconColor: 'text-white',
    sectionId: 'growth'
  }, {
    title: 'Consulting',
    description: 'Custom AI growth tools built for you.',
    icon: <HandshakeIcon className="w-8 h-8" data-id="element-308" />,
    color: 'from-orange-500 to-orange-400',
    iconColor: 'text-white',
    sectionId: 'consulting'
  }];
  return <section className="pt-36 pb-20 md:pt-40 md:pb-28 text-center relative overflow-hidden" data-id="element-309">
      <div className={`transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-310">
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-311">
          For creators who want to{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-312">
            stay ahead
          </span>
          .
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-313">
          AI that scales your influence and income, built for the modern creator
          economy.
        </p>
      </div>
      {/* Service Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-314">
        {services.map((service, index) => <a key={index} href={`#${service.sectionId}`} onClick={e => scrollToSection(e, service.sectionId)} className="block" data-id="element-315">
            <div className="flex flex-col items-center bg-white p-7 rounded-xl shadow-md border border-gray-100 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer h-full" onMouseEnter={() => setHoveredCard(index)} onMouseLeave={() => setHoveredCard(null)} data-id="element-316">
              <div className={`bg-gradient-to-br ${service.color} ${service.iconColor} p-6 rounded-2xl mb-6 w-20 h-20 flex items-center justify-center transition-transform duration-300 ${hoveredCard === index ? 'scale-110' : ''}`} data-id="element-317">
                {service.icon}
              </div>
              <h3 className="font-medium text-lg mb-2" data-id="element-318">{service.title}</h3>
              <p className="text-gray-600 text-center" data-id="element-319">{service.description}</p>
              <div className={`mt-4 text-blue-600 font-medium transition-opacity duration-300 ${hoveredCard === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-320">
                Learn more →
              </div>
            </div>
          </a>)}
      </div>
    </section>;
};